import { useRequestGetUserData } from '@/hooks/httpRequest';
import { useParams } from 'react-router-dom';

const useUser = () => {

  const { userId } = useParams();
  const result = useRequestGetUserData({ userId: userId! });

  return ({
    ...result,
    userId
  });

};

export default useUser;
